/**
 * StatusBadge — Color-coded license tier badge for the portal.
 */

const VARIANTS = {
    active: {
        bg: 'bg-emerald-100 dark:bg-emerald-900/40',
        text: 'text-emerald-800 dark:text-emerald-300',
        label: 'Pro Active',
    },
    PRO_ACTIVE: {
        bg: 'bg-emerald-100 dark:bg-emerald-900/40',
        text: 'text-emerald-800 dark:text-emerald-300',
        label: 'Pro Active',
    },
    PRO_EXPIRED_UPDATES: {
        bg: 'bg-amber-100 dark:bg-amber-900/40',
        text: 'text-amber-800 dark:text-amber-300',
        label: 'Updates Expired',
    },
    revoked: {
        bg: 'bg-red-100 dark:bg-red-900/40',
        text: 'text-red-800 dark:text-red-300',
        label: 'Revoked',
    },
    PRO_REVOKED: {
        bg: 'bg-red-100 dark:bg-red-900/40',
        text: 'text-red-800 dark:text-red-300',
        label: 'Revoked',
    },
    FREE: {
        bg: 'bg-zinc-200 dark:bg-zinc-700',
        text: 'text-zinc-700 dark:text-zinc-300',
        label: 'Free',
    },
};

export function StatusBadge({ status }) {
    const v = VARIANTS[status] ?? VARIANTS.FREE;
    return (
        <span
            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${v.bg} ${v.text}`}
        >
            {v.label}
        </span>
    );
}
